import SearchResults from "src/components/text/search-results";

export default function parseSearchResults(searchResults?: string) {
  if (!searchResults) return null;
  return <SearchResults text={searchResults} />;
}
